import { UPDATE_SELECTED_LANGUAGE, GET_HOMEPAGE_DATA , RESET_HOMEPAGE_DATA, SET_HOMEPAGE_DATA, SET_CHARITY_ID, SET_DONATION_TYPEID, RESET_RATE_SETTING  } from '../constants';

export function setHomePageData(homepage){
    return {
        type: SET_HOMEPAGE_DATA,
        homepage
    }
}

export function getHomePageData(){
    return {
        type: GET_HOMEPAGE_DATA,
    }
}

export function resetHomepageData(){
    return {
        type: RESET_HOMEPAGE_DATA,
    }
}

export function updateSelectedLang(lang){
    return {
        type: UPDATE_SELECTED_LANGUAGE,
        lang
    }
}

export const setCharityId = (charityId) => {
    return {
        type: SET_CHARITY_ID,
        payload: charityId,
    };
};

export const setDonationTypeId = (donationTypeId) => {
    return {
        type: SET_DONATION_TYPEID,
        payload: donationTypeId,
    };
};


export function resetRateSetting(){
    return {
        type: RESET_RATE_SETTING,
    }
}
